import { BrowserModule } from '@angular/platform-browser'
import { LOCALE_ID, NgModule } from '@angular/core'
// import { RouterModule } from '@angular/router'
import { HttpClientModule } from '@angular/common/http'
import { FormsModule }   from '@angular/forms'
import { registerLocaleData } from '@angular/common';

import { AgmCoreModule } from '@agm/core'

import { AppComponent } from './app.component'
// import { NavComponent } from './nav/nav.component'
// import { AppRoutingModule } from './/app-routing.module'
import { OrdersComponent } from './orders/orders.component'
// import { CustomersComponent } from './customers/customers.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { HomeComponent } from './home/home.component'
import { LoginComponent } from './login/login.component'
import { CallbackComponent } from './callback/callback.component'
// import { ArticlesComponent } from './articles/articles.component'
import { ArticleDetailComponent } from './article-detail/article-detail.component'
import { CustomerDetailComponent } from './customer-detail/customer-detail.component'
import { AuthorizeComponent } from './authorize/authorize.component'
import { ProductsComponent } from './products/products.component'

import localeNb from '@angular/common/locales/nb';
import { ShoppingCartComponent } from './shopping-cart/shopping-cart.component';
import { ImageResponsiveDirective } from './image-responsive.directive';
import { GalleryComponent } from './gallery/gallery.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderFormComponent } from './header-form/header-form.component';
import { ContactComponent } from './contact/contact.component';
registerLocaleData(localeNb, 'nb');

@NgModule({
  declarations: [
    AppComponent,
    // NavComponent,
    OrdersComponent,
    // CustomersComponent,
    HomeComponent,
    LoginComponent,
    CallbackComponent,
    // ArticlesComponent,
    ArticleDetailComponent,
    CustomerDetailComponent,
    AuthorizeComponent,
    ProductsComponent,
    ShoppingCartComponent,
    ImageResponsiveDirective,
    GalleryComponent,
    DashboardComponent,
    HeaderFormComponent,
    ContactComponent
  ],
  imports: [
    FormsModule,
    HttpClientModule,
    BrowserModule,
    // AppRoutingModule,
    FontAwesomeModule,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyDfQWlMcsQCdNtn2W2OUnThaFM6Uzw4tPM' })
  ],
  exports: [],
  providers: [ { provide: LOCALE_ID, useValue: 'nb' } ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {
    console.log('-- app constructor --');
  }
}
